import { Message } from 'element-ui';

const showMessage = Symbol('showMessage');
class DonMessage {
  success(options: any, single = true) {
    this[showMessage]('success', options, single);
  }

  warning(options: any, single = true) {
    this[showMessage]('warning', options, single);
  }

  info(options: any, single = true) {
    this[showMessage]('info', options, single);
  }

  error(options: any, single = true) {
    this[showMessage]('error', options, single);
  }

  [showMessage](type: string | number, options: any, single: any) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        (Message as any)[type](options);
      }
    } else {
      (Message as any)[type](options);
    }
  }
}
export default new DonMessage();
